<template>
  <div>
    <el-drawer
      direction="btt"
      size="50%"
      :visible="HesapModal">
      <div class="aimodal" v-if="HizmetBilgi">
        <h5 class="text-center" style="padding: 10px;margin:0">Fabsis Hesap Bilgi
          <a class="float-right" @click="$emit('HesapModal', false)">
            <i class="el-icon-close"></i></a>
        </h5>
        <Yukleniyor :data="lo"></Yukleniyor>
        <el-row :gutter="24">
          <div>
            <el-col :span="6" :offset="3">
              <div class="HizmetBilgi">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th colspan="4" class="text-center">Kullanım Detayları
                      <a @click="SayfaYukle" class="text-mavi float-right">Yenile</a>
                    </th>
                  </tr>
                  <tr>
                    <th>Hizmet</th>
                    <th class="text-right">Satın Alınan</th>
                    <th class="text-right">Sarfiyat</th>
                    <th class="text-right">Bakiye</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Abone</td>
                    <td class="text-right">{{ HizmetBilgi.Mesken.AlinanText }}</td>
                    <td class="text-right">{{ HizmetBilgi.Mesken.SarfText }}</td>
                    <td class="text-right">{{ HizmetBilgi.Mesken.KalanText }}</td>
                  </tr>
                  <tr>
                    <td><b>{{ HizmetBilgi.SmsBaslik }}</b> Başlıklı Sms</td>
                    <td class="text-right">{{ HizmetBilgi.Sms.AlinanText }}</td>
                    <td class="text-right">{{ HizmetBilgi.Sms.SarfText }}</td>
                    <td class="text-right">{{ HizmetBilgi.Sms.KalanText }}</td>
                  </tr>
                  <tr>
                    <td>Süre</td>
                    <td class="text-right">{{ HizmetBilgi.Sure.AlinanText }}</td>
                    <td class="text-right">{{ HizmetBilgi.Sure.SarfText }}</td>
                    <td class="text-right">{{ HizmetBilgi.Sure.KalanText }}</td>
                  </tr>

                  </tbody>
                </table>

                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th colspan="2" class="text-center">Hesap Bilgi</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Kayıt Tarihi</td>
                    <td class="text-right">{{ HizmetBilgi.Tarih }}</td>
                  </tr>
                  <tr>
                    <td>Fatura Ünvanı</td>
                    <td class="text-right">{{ HesapBilgi.Unvan }}</td>
                  </tr>
                  <tr>
                    <td>Vergi Dairesi / Vergi No.</td>
                    <td class="text-right">{{ HesapBilgi.vDaire }} / {{ HesapBilgi.vNo }}</td>
                  </tr>
                  <tr>
                    <td>Şehir</td>
                    <td class="text-right">{{ HesapBilgi.Sehir }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="HizmetBilgi">
                <div class="odemeyap">
                  <h5>Kredi Kartı ile Ödeme Yap</h5>
                  <el-input placeholder="Ödeme Tutarı" size="mini" v-model="Tutar" class="input-with-select">
                    <el-button @click="OdemeOnay(Tutar)" size="mini" slot="append" type="success" icon="el-icon-check">
                      Ödeme Yap
                    </el-button>
                  </el-input>
                </div>
                <div class="HizmetBilgi">

                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th colspan="2" class="text-center">Ekstra Ürün ve Hizmetler</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{{ HizmetBilgi.SmsBaslik }} Başlıklı SMS</td>
                      <td>
                        <el-select v-model="Tutar" @change="OdemeOnay" :disabled="!HizmetBilgi.SmsBaslik">
                          <el-option
                            v-for="item in SmsKredi"
                            :label="item.Kredi"
                            :value="item.Tutar">
                          </el-option>
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <td>Modül ve Gereksinimleri</td>
                      <td>
                        <el-select v-model="Tutar" @change="OdemeOnay" :disabled="$store.getters.Paket!=1">
                          <el-option
                            v-for="item in Ekstra"
                            :label="item.Adi"
                            :value="item.Tutar">
                          </el-option>
                        </el-select>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </el-col>
            <el-col :span="6">

              <table class="table table-hover">
                <thead>
                <tr>
                  <th class="text-center">Kurumsal Bilgiler</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <small class="d-block">Ticari Ünvan</small>
                    Aidatım İnovasyon Yazılım Teknolojileri San. ve Tic.Ltd.Şti.
                  </td>
                </tr>
                <tr>
                  <td>
                    <small class="d-block">Vergi Bilgileri</small>
                    Erciyes Vd. / 0100628286
                  </td>
                </tr><tr>
                  <td>
                    <small class="d-block">Mersis</small>
                    0010062828600001
                  </td>
                </tr>

                </tbody>
              </table>
              <table class="table table-hover">
                <thead>
                <tr>
                  <th class="text-center">Hesap Numaraları</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td><img
                    src="https://pos.mudu.pro/oi/banka/finans.png" class="pull-left" width="50"> <b
                    class="pull-right" id="Finans">TR 26 0011 1000 0000 0072 3527 28 </b></td>
                </tr>
                <tr>
                  <td><img
                    src="https://pos.mudu.pro/oi/banka/kuveytturk.png" class="pull-left" width="50"> <b
                    class="pull-right" id="Kuveyt">TR 67 0020 5000 0960 6224 6000 01</b></td>
                </tr>

                </tbody>
              </table>
            </el-col>
          </div>
        </el-row>
      </div>

    </el-drawer>
    <el-dialog
      append-to-body
      v-if="OdemeModal"
      title="Kredi Kartı ile Online Ödeme"
      :visible.sync="OdemeModal"
      center
      width="30%">
      <a @click="OdemeModal = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <iframe :src="Url"></iframe>
    </el-dialog>
  </div>
</template>

<script>

import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: {
    HesapModal: Boolean
  },
  data() {
    return {
      Tutar: null,
      lo: false,
      OdemeModal: false,
      Url: null,
      HizmetBilgi: null,
      HesapBilgi: null,
      SmsKredi: [
        {Adi: "1.000 Kredi", Tutar: 28},
        {Adi: "5.000 Kredi", Tutar: 119},
        {Adi: "10.000 Kredi", Tutar: 219},
        {Adi: "25.000 Kredi", Tutar: 525},
        {Adi: "50.000 Kredi", Tutar: 890},
        {Adi: "100.000 Kredi", Tutar: 1249}
      ],
      Ekstra: [
        {Adi: "Güvenlik Sertifikası", Tutar: 250},
        {Adi: "Özel Web Tasarım Sitesi", Tutar: 1250},
        {Adi: "Sınırsız Banka Entegrasyonu", Tutar: 1250},
        {Adi: "Tahsilat Merkezi", Tutar: 1000},
        {Adi: "PRO", Tutar: 1000},
      ]
    }
  },
  methods: {
    OdemeOnay(Tutar) {
      if (Tutar) this.Tutar = Tutar;
      this.lo = true;
      this.$store.dispatch("Post", {Tutar: this.Tutar, path: 'spesiyal/hesapbilgi/'})
        .then(response => {
          if (response.Durum === 'OK') {
            //this.OdemeModal = true;
            this.lo = false;
            this.Url = response.Link;
            window.open(this.Url, "MsgWindow", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=400,height=700");

          }
        });
    },
    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'spesiyal/hesapbilgi/'})
        .then(response => {
          if (response.Durum === 'OK') {

            this.HizmetBilgi = response.Bilgi;
            localStorage.setItem("_aiHizmet", JSON.stringify(response.Bilgi));
          }
        });
      this.$store.dispatch("Get", {path: 'spesiyal/sistem'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.HesapBilgi = response.Data;
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>
.odemeyap {
  margin-bottom: 20px;
  border: 1px solid #EBEEF5;
  padding: 10px;
}

.odemeyap h5 {
  font-size: 12px;
  text-align: center;
  background: #EBEEF5;
  padding: 5px;
}

iframe {
  width: 100%;
  border: none;
  height: 700px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/Hesap.vue